import { useQuery } from "@tanstack/react-query";

import { Card, CardContent } from "@/components/ui/card";
import { Alert, AlertDescription } from "@/components/ui/alert";

import { getSummary } from "./api";
import { BreakoutPage } from "./TrafficPage";
import { useControls } from "./controls";
import { formatTtuValue } from "./format";

export function ConversionPage({ areaName }: { areaName: string }) {
  const controls = useControls();
  const summary = useQuery({ queryKey: ["meteoric_units_sold", "summary", controls.toQuery()], queryFn: () => getSummary(controls.toQuery()) });
  const step = summary.data?.data.steps.units_per_order;
  const extra = summary.isError
    ? <Alert><AlertDescription>Units per order could not be read.</AlertDescription></Alert>
    : step ? <Card><CardContent><p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Units per order</p><p className="mt-2 text-2xl font-semibold tabular-nums text-ks-ink">{formatTtuValue(step.value, step.unit)}</p></CardContent></Card> : undefined;
  return <BreakoutPage step="conversion" areaName={areaName} extra={extra} />;
}
